export default __webpack_public_path__ + "images/7d40cd7b6abdca050ac6986b8e459d8b.svg";